(function ($) {
    'use strict';

    function createFolder(opts, callback) {
        var $modal = $(generateModalHTML($.extend({
            title: gettext("Add new folder"),
            actionUrl: opts.createFolderUrl,
            submitLabel: pgettext("Folder", "Add"),
        }, opts)));

        return openFolderModal($modal, callback);
    }

    function editFolder(opts, callback) {
        var $modal = $(generateModalHTML($.extend({
            title: gettext("Edit folder"),
            actionUrl: opts.updateUrl,
            submitLabel: gettext("Save"),
        }, opts)));

        return openFolderModal($modal, callback);
    }

    function openFolderModal($modal, callback) {
        var $validationError = $modal.find('.validation-error');

        $modal.one('hidden.bs.modal', function () {
            $modal.remove()
        });

        $modal.find('form').ajaxForm({
            dataType: 'json',
            beforeSubmit: function () {
                $modal.find('input, button').prop('disabled', true);
                $validationError.text('');
            },
            success: function (data) {
                callback(data)
                $modal.modal('hide');
            },
            error: function (data) {
                $modal.find('input, button').prop('disabled', false);
                if (data.responseJSON) {
                    $validationError.text(
                        $.map(data.responseJSON, function (v, k) {
                            return v;
                        }).join(", ")
                    );
                } else {
                    $validationError.text(gettext("Unknown error occured"));
                    Sentry.captureMessage('Failed to save folder with HTTP status: ' + data.status, {
                        extra: {
                            response: data,
                        }
                    });
                }
            },
        });

        $modal.appendTo($('body')).modal({
            backdrop: false
        });
    }

    function generateModalHTML(opts) {
        const folderNameStr = pgettext("Folder", "Name");

        return `
            <!-- Modal -->
            <div class="modal fade" id="new-folder-modal" tabindex="-1" role="dialog" aria-labelledby="new-folder-modal-title" aria-hidden="true">
              <div class="modal-dialog modal-sm">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title" id="new-folder-modal-title">
                        ${opts.title}
                    </h4>
                  </div>
                    <form method="post" action="${opts.actionUrl}">
                        <div class="modal-body">
                            <input name="name" value="${opts.name || ''}" placeholder="${folderNameStr}" class="form-control"/>
                            <input type="hidden" name="parent" value="${opts.parent || ''}"/>
                            <input type="hidden" name="context" value="${opts.context}"/>
                            <div class="validation-error"></div>
                            <input type="hidden" name="csrftoken" value="${$.cookie('weekly_csrf')}"/>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">${gettext("Cancel")}</button>
                        <button type="submit" class="btn btn-primary">${opts.submitLabel}</button>
                      </div>
                    </form>
                </div><!-- /.modal-content -->
              </div><!-- /.modal-dialog -->
            </div><!-- /.modal -->
        `;
    }

    $(function () {
        $.createFolder = createFolder;
        $.editFolder = editFolder;
    })
})(jQuery);



// WEBPACK FOOTER //
// ./weekly/static/js/createFolder.js